import React, { useEffect, useState } from 'react';
import { MotifModal, MotifModalBody, MotifModalHeader, MotifIcon } from '@ey-xd/motif-react';
import { actionIcLockOutline24px } from '@ey-xd/motif-react/assets/icons';
import { BodyContent, HeaderWrapper, ParagraphStyle } from '@organisms/modals/styles/modalStyles';
import { isMobile } from 'react-device-detect';
import '@styles/commonStyles.css';
import { FORBIDDEN_ACCESS_MODAL } from '@constants/commonConstants';
import { useNavigate } from 'react-router-dom';

const ForbiddenAccessModal = () => {
  const [isModalVisible, setModalVisivility] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('isSuperUser') === 'true') {
      navigate('/super-user');
    } else {
      // Clearing the local storage and session storage for the user
      localStorage.clear();
      sessionStorage.clear();
    }
  }, []);

  const showAccessdeniedModal = () => {
    setModalVisivility(true);
  };

  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;
  const bodyContent = (
    <BodyContent>
      <p>{FORBIDDEN_ACCESS_MODAL.DESCRIPTION1}</p>
      <p>{FORBIDDEN_ACCESS_MODAL.DESCRIPTION2}</p>
    </BodyContent>
  );
  const headerTitle = (
    <span style={{ marginLeft: 11, fontSize: 16 }}>{FORBIDDEN_ACCESS_MODAL.HEADER_TITLE}</span>
  );

  return (
    <MotifModal
      variant="alt"
      show={isModalVisible}
      onClose={showAccessdeniedModal}
      size={isMobile ? 'sm' : 'md'}
      className={`${isMobile ? 'motif-Modal-mobile' : ''}`}
      focusTrapOptions={{ fallbackFocus: '[data-testid="modal-container"]' }}
    >
      <div data-testid="modal-container">
        <MotifModalHeader closeModalButton={true}>
          <Header>
            <MotifIcon style={{ color: '#F95D54' }} src={actionIcLockOutline24px} />
            {headerTitle}
          </Header>
        </MotifModalHeader>
        <MotifModalBody>
          <ParagraphStyle>{bodyContent}</ParagraphStyle>
        </MotifModalBody>
      </div>
    </MotifModal>
  );
};

export default ForbiddenAccessModal;
